const getters = {
  userType: state => state.user.userType,
  userId:state => state.user.userId,
  enterpriseInfo:state => state.user.enterpriseInfo,
  filled:state => state.user.enterpriseFilled,
  userInfo:state => state.user.userInfo,
  ability:state => state.user.ability,
  site:state => state.app.site,
  isHR:state => state.user.isHR
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js